<template>
  <div>
    <script type="application/javascript">
      fbq('track', 'ViewContent');
    </script>
    <masonry :cols="{default: 3, 1300: 2, 700: 1}" :gutter="{default: '15px'}"
             class="masonry">
      <div>
        <product-info v-if="product.data" v-model="product.data" :editing="editing" @startEditing="startEditing" />
      </div>
      <div>
        <div class="card" v-if="product.data">
          <h1 class="card__title__border">{{ $t('messages.description') }}</h1>
          <div class="card__description pt-20" v-html="product.data.description_bgg"></div>
        </div>
        <div class="card" v-if="product.data && product.data.video">
          <h1 class="card__title__border">{{ $t('messages.video') }}</h1>
          <div class="card__description pt-20">
            <b-embed type="iframe" aspect="16by9" :src="embedVideo" allowfullscreen></b-embed>
          </div>
        </div>
      </div>
      <div>
        <div class="card" v-if="product.data">
          <h1 class="card__title__border">{{ $t('messages.extra_info') }}</h1>
          <div class="card__description pt-20">
            <p class="font-weight-bold mb-2">{{ $t('messages.ean') }}:</p>
            <p class="mb-2" v-if="product.data.ean">{{ product.data.ean }}</p>
            <p class="mb-2 font-italic" v-if="!product.data.ean">{{ $t('messages.unknown') }}</p>
            <p class="font-weight-bold mb-2" v-if="product.data.year">{{ $t('messages.year') }}:</p>
            <p class="mb-2" v-if="product.data.year">{{ product.data.year }}</p>
            <p class="font-weight-bold mb-2" v-if="product.data.min_players || product.data.max_players">{{ $t('messages.total_players') }}:</p>
            <p class="mb-2" v-if="product.data.min_players || product.data.max_players">{{ product.data.min_players }} - {{ product.data.max_players }}</p>
            <p class="font-weight-bold mb-2" v-if="product.data.age">{{ $t('messages.age') }}:</p>
            <p class="mb-2" v-if="product.data.age">{{ product.data.age }}</p>
            <p class="font-weight-bold mb-2" v-if="product.data.language_dependency_level">{{ $t('messages.language_dependency') }}:</p>
            <p class="mb-2" v-if="product.data.language_dependency_level">{{ $t('messages.language_dependency_' + product.data.language_dependency_level) }}</p>
            <p class="font-weight-bold mb-2" v-if="product.data.min_play_time && product.data.max_play_time">{{ $t('messages.play_time') }}:</p>
            <p class="mb-2" v-if="product.data.min_play_time && product.data.max_play_time">{{ product.data.min_play_time }} - {{ product.data.max_play_time }} {{ $t('time.minutes') }}</p>
            <p class="font-weight-bold mb-2" v-if="product.data.designer">{{ $t('messages.designer') }}:</p>
            <p class="mb-2" v-if="product.data.designer">{{ product.data.designer }}</p>
            <p class="font-weight-bold mb-2" v-if="product.data.publisher">{{ $t('messages.publisher') }}:</p>
            <p class="mb-2" v-if="product.data.publisher">{{ product.data.publisher }}</p>
            <p class="font-weight-bold mb-2" v-if="product.data.rating">{{ $t('messages.rating') }}:</p>
            <p class="mb-2" v-if="product.data.rating">{{ product.data.rating | round(1) }}/10.0</p>
          </div>
        </div>
      </div>
    </masonry>
  </div>
</template>

<script>
import Vue from 'vue'
import VueMasonry from 'vue-masonry-css'
import VueMoment from 'vue-moment'
import NotificationButton from '../../components/NotificationButton'
import ProductInfo from '../../components/product/ProductInfo'

import { defaultMixin } from '../../mixin/default'
import { notificationMixin } from '../../mixin/notification'

import { productService } from '../../services/product.service'
import { validationMixin } from 'vuelidate'

Vue.use(VueMasonry)
Vue.use(VueMoment)

export default {
  name: 'product',
  metaInfo: function () {
    return {
      title: this.productName + ' - CrowdFinder',
      meta: [
        {
          'property': 'og:title',
          'content': this.productName,
          'vmid': 'og:title'
        },
        {
          'property': 'og:description',
          'content': this.productDescription,
          'vmid': 'og:description'
        },
        {
          'property': 'og:image',
          'content': this.productImage,
          'vmid': 'og:image'
        },
        {
          'property': 'description',
          'content': this.productName,
          'vmid': 'description'
        },
        {
          'property': 'keywords',
          'content': this.productName,
          'vmid': 'keywords'
        }
      ]
    }
  },
  mixins: [ defaultMixin, notificationMixin, validationMixin ],
  components: { ProductInfo, NotificationButton },
  data: function () {
    return {
      editing: false,
      product: {
        data: null
      },
      bgg: {
        id: null,
        year: null,
        minPlayers: null,
        maxPlayers: null,
        bestWith: null,
        age: null,
        languageDependencyLevel: null,
        minPlayTime: null,
        maxPlayTime: null,
        designer: null,
        publisher: null,
        video: null,
        rating: null
      }
    }
  },
  computed: {
    productName: function () {
      if (this.product.data !== null && this.product.data.name !== null) {
        return this.product.data.name
      }
      return ''
    },
    productDescription: function () {
      if (this.product.data !== null && this.product.data.description !== null) {
        return this.product.data.description.replace(/(<([^>]+)>)/ig, '')
      }
      return ''
    },
    productImage: function () {
      if (this.product.data !== null && this.product.data.image !== null) {
        return this.product.data.image
      }
      return ''
    },
    embedVideo: function () {
      if (this.product.data.video) {
        return this.product.data.video.replace('watch?v=', 'embed/')
      }
      return null
    },
    currentLocation: function () {
      return window.location.href
    }
  },
  methods: {
    fetchProduct: function () {
      let id = this.$route.params.id
      let store = this.$store

      productService.get(id)
        .then((product) => {
          this.product.data = product
          this.createProductJSON()

          if (!this.product.data.product_range) {
            store.commit('warning', 'errors.product_out_of_range')
          }
        }, () => {
          store.commit('error', 'errors.product')
        })
    },
    startEditing: function (editing) {
      let self = this
      let loader = this.$loading.show()
      setTimeout(function () {
        self.editing = editing
        loader.hide()
      }, 100)
    },
    clearProductJSON: function () {
      let oldScript = null
      var scripts = document.getElementsByTagName('script')
      for (var i = 0; i < scripts.length; ++i) {
        if (scripts[i].getAttribute('type') === 'application/ld+json') {
          oldScript = scripts[i]
        }
      }
      if (oldScript !== null) {
        oldScript.parentElement.removeChild(oldScript)
      }
    },
    createProductJSON: function () {
      let script = document.createElement('script')
      script.setAttribute('type', 'application/ld+json')
      let json = {
        '@context': 'https://schema.org/',
        '@type': 'Product',
        'name': this.product.data.name,
        'image': [
          this.product.data.image
        ],
        'description': this.product.data.description_bgg,
        'sku': this.product.data.ean,
        'mpn': this.product.data.id,
        'brand': {
          '@type': 'Thing',
          'name': this.product.data.publisher
        },
        'offers': {
          '@type': 'Offer',
          'url': this.currentLocation,
          'priceCurrency': 'EUR',
          'price': this.product.data.price,
          'itemCondition': 'https://schema.org/NewCondition',
          'availability': 'https://schema.org/InStock',
          'seller': {
            '@type': 'Organization',
            'name': 'CrowdFinder'
          }
        }
      }
      script.innerHTML = JSON.stringify(json)
      document.head.appendChild(script)
    }
  },
  created: function () {
    this.$root.$on('resetNotification', (notification) => {
      this.resetNotification(notification)
    })
  },
  mounted: function () {
    this.fetchProduct()
  },
  beforeDestroy: function () {
    let oldScript = null
    var scripts = document.getElementsByTagName('script')
    for (var i = 0; i < scripts.length; ++i) {
      if (scripts[i].getAttribute('type') === 'application/ld+json') {
        oldScript = scripts[i]
      }
    }
    if (oldScript !== null) {
      oldScript.parentElement.removeChild(oldScript)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .masonry {
    padding: 10px;
  }

  .card__info {
    border-bottom: 1px #D3D3D3 solid;
  }

  .fa-disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
</style>



// WEBPACK FOOTER //
// src/pages/product/Product.vue